import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '../../service/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PraxisService } from './praxis/service/praxis.service';
import { Location } from '@angular/common';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { OverlayContainer } from '@angular/cdk/overlay';
import { PerfilWeb } from './automotor/interface/perfil_web';
import { ThemeService } from '../../service/theme-service.service';

@Component({
    selector: 'app-cotizador',
    templateUrl: './cotizador.component.html',
    styleUrl: './cotizador.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CotizadorComponent implements OnInit{
  plataformaEnMantenimiento: number = 0; // Se debe leer desde archivo de configuración
  isMobile: boolean = false;

  uuid: any = '';
  token: string = '';
  activatedRoute: ActivatedRoute | null | undefined;
  perfil: PerfilWeb | undefined;


  ramos = [
  { nombre: 'auto', img: 'assets/iconos/auto.svg', label: 'Auto', onClick: () => this.clickAuto('auto') },
  { nombre: 'moto', img: 'assets/iconos/moto.svg', label: 'Moto', onClick: () => this.clickMoto('moto') },
  { nombre: 'praxis', img: 'assets/iconos/doctor.svg', label: 'Praxis Médica', onClick: () => this.clickPraxis() },
  { nombre: 'prepaga', img: 'assets/iconos/prepaga.png', label: 'Medicina Prepaga', onClick: () => this.clickPrepaga() },
  { nombre: 'art', img: 'assets/iconos/prepaga.png', label: 'ART', onClick: () => this.clickART() }
];
ramoActivo: string | null = null;

  // Efecto visual de presionado para los botones
  setPressed(event: Event, pressed: boolean) {
    const el = event.currentTarget as HTMLElement;
    if (el && el.classList) {
      if (pressed) {
        el.classList.add('boton-pressed');
      } else {
        el.classList.remove('boton-pressed');
      }
    }
  }
  isLoading: boolean = true; // Controla el estado del loading
  showModal: boolean = false;

constructor (
  private router: ActivatedRoute,
  private ruta: Router,
  private themeService: ThemeService,
  private location: Location,
  private cdr: ChangeDetectorRef, // Inyectar ChangeDetectorRef
  private configService: ConfigService
) {}

ngOnInit(): void {
  // Detectar si es dispositivo móvil
  this.isMobile = window.innerWidth <= 768;
  this.token = localStorage.getItem('token') || '';

  // Leer config.json para saber si está en mantenimiento
  this.configService.getConfig().subscribe(config => {
    this.plataformaEnMantenimiento = config.mantenimiento;
  });

  // Suscribirse a los cambios en los parámetros de la ruta
  this.router.paramMap.subscribe(params => {
    const newUuid = params.get('uuid');
    if (newUuid) {
      localStorage.clear();
      this.uuid = newUuid;
      localStorage.setItem('uuid', this.uuid);
      localStorage.setItem('token', this.token);
      this.cargarPerfil();
    } else {
      this.uuid = localStorage.getItem('uuid');
      if (this.uuid) {
        this.cargarPerfil();
      } else {
        alert('El enlace está mal formado. Por favor, verifique e intente nuevamente.');
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    }
  });
  if (this.perfil?.pas_view_flayer === '1') {
    setTimeout(() => {
      this.openModal();
      this.cdr.detectChanges();
    }, 3000);
  }

}

openModal() {
  this.showModal = true;
}

closeModal() {
  this.showModal = false;
}

private cargarPerfil(): void {
  this.themeService.obtenerPerfil(this.token).subscribe(
    (perfil) => {
      this.perfil = perfil;
      this.consultar_tema();
    },
    (error) => {
      console.error('Error al cargar el perfil:', error);
      alert('Hubo un problema al cargar el perfil. Por favor, intente nuevamente.');
      this.isLoading = false; // Ocultar el loading
      this.cdr.detectChanges(); // Forzar la detección de cambios
    }
  );
}

private consultar_tema() {
  this.themeService.getThemeColors(this.token, this.perfil?.pas_color_primario, this.perfil?.pas_color_secundario).subscribe(
    (colors) => {
      //console.log(colors);
      this.isLoading = false; // Ocultar el loading después de cargar la personalización
      this.cdr.detectChanges(); // Forzar la detección de cambios
    },
    (error) => {
      console.error('Error al cargar los colores del tema:', error);
      this.isLoading = false; // Asegurarse de ocultar el loading incluso si hay un error
      this.cdr.detectChanges(); // Forzar la detección de cambios
    }
  );
}

clickAuto(tipo: string){
  localStorage.setItem('tipo_vehiculo', tipo);
  if (this.plataformaEnMantenimiento === 1) {
    this.ruta.navigate(['/cotizador/mantenimiento']);
  } else {
    this.ruta.navigate([`/cotizador/automotor`]);
  }
}

clickMoto(tipo: string){
  localStorage.setItem('tipo_vehiculo', tipo);
  if (this.plataformaEnMantenimiento === 1) {
    this.ruta.navigate(['/cotizador/mantenimiento']);
  } else {
    this.ruta.navigate([`/cotizador/motovehiculo`]);
  }
}

clickPraxis(){
  if (this.plataformaEnMantenimiento === 1) {
    this.ruta.navigate(['/cotizador/mantenimiento']);
  } else {
    this.ruta.navigate([`/cotizador/praxis`]);
  }
}

clickPrepaga(){
  if (this.plataformaEnMantenimiento === 1) {
    this.ruta.navigate(['/cotizador/mantenimiento']);
  } else {
    this.ruta.navigate([`/cotizador/prepaga`]);
  }
}

clickART(){
  if (this.plataformaEnMantenimiento === 1) {
    this.ruta.navigate(['/cotizador/mantenimiento']);
  } else {
    this.ruta.navigate([`/cotizador/art`]);
  }
}

}
